module.exports = __webpack_public_path__ + "site/img/servicesen.e94af172.png";